import React, { Component } from 'react';
import Img from '../Img';

import styles from './BackgroundImage.scss';

class BackgroundImage extends Component {
    constructor(props) {
        super(props);

        this.setImgRef = this.setImgRef.bind(this);
        this.updateImage = this.updateImage.bind(this);
        this.image = null;
    }

    componentDidMount() {
        if (this.image) {
            this.image.addEventListener('load', this.updateImage);
            if (this.image.complete) {
                this.updateImage();
            }
        }
    }

    setImgRef(img) {
        this.image = img;
        if (this.image) {
            this.image.addEventListener('load', this.updateImage);
            if (this.image.complete) {
                this.updateImage();
            }
        }
    }

    updateImage(imageRef) {
        const { backgroundGradiant, backgroundOverlay, overlayPercent, overlayStyleCss } = this.props;
        const img = this.image || imageRef;
        if (img) {
            const src = img.currentSrc ? img.currentSrc : img.src;
            if (backgroundGradiant) {
                img.parentNode.style.backgroundImage = `linear-gradient(to bottom, transparent 0%, transparent 50%, rgba(0, 0, 0, 0.5) 100%), url("${src}")`;
            } else if (backgroundOverlay) {
                if (overlayStyleCss) {
                    img.parentNode.style.backgroundImage = `${overlayStyleCss}, url("${src}")`;
                } else if (typeof backgroundOverlay === 'boolean') {
                    if (typeof overlayPercent === 'string' || typeof overlayPercent === 'number') {
                        img.parentNode.style.backgroundImage = `linear-gradient(to bottom, rgba(0, 0, 0, 0.${overlayPercent}) 0%, rgba(0, 0, 0, 0.${overlayPercent}) 100%), url("${src}")`;
                    } else {
                        img.parentNode.style.backgroundImage = `linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%), url("${src}")`;
                    }
                } else if (typeof backgroundOverlay === 'string' || typeof backgroundOverlay === 'number') {
                    img.parentNode.style.backgroundImage = `linear-gradient(to bottom, rgba(0, 0, 0, 0.${backgroundOverlay}) 0%, rgba(0, 0, 0, 0.${backgroundOverlay}) 100%), url("${src}")`;
                }
            } else {
                img.parentNode.style.backgroundImage = `url("${src}")`;
            }
        }
    }

    render() {
        const { baseUrl, defaultImage, imageType, images, extraCls, children, parentStylesClass, style, overlayPercent, useRawSrcSet } = this.props;
        const imageIsAvailable = !!images && !!images[imageType] && !!images[imageType].oneX && !!images[imageType].twoX && !!images[imageType].threeX;
        const defaultAvailable = !!images && !!images.default;
        const bgOpacity = overlayPercent ? `0.${100 - parseInt(overlayPercent)}` : '1';

        return (
            <div
                className={`${styles.backgroundImage} ${extraCls ? styles[extraCls] : ''} ${parentStylesClass || ''}`}
                style={style}
            >
                {imageIsAvailable && (
                    <Img
                        src={`${baseUrl}${images.default}`}
                        srcSet={`
                        ${baseUrl}${images[imageType].oneX} 1x,
                        ${baseUrl}${images[imageType].twoX} 2x,
                        ${baseUrl}${images[imageType].threeX} 3x`}
                        defaultimg={defaultImage}
                        onImgLoad={this.updateImage}
                        style={{ opacity: bgOpacity }}
                        useRawSrcSet={useRawSrcSet}
                    />
                )}
                {!imageIsAvailable && defaultAvailable && (
                    <Img
                        src={`${baseUrl}${images.default}`}
                        defaultimg={defaultImage}
                        onImgLoad={this.updateImage}
                        style={{ opacity: bgOpacity }}
                    />
                )}
                {!imageIsAvailable && !defaultAvailable && defaultImage && (
                    <Img
                        src={`${defaultImage}`}
                        onImgLoad={this.updateImage}
                        style={{ opacity: bgOpacity }}
                    />
                )}
                {children}
            </div>
        );
    }
}

export default BackgroundImage;
